import { useCallback } from 'react';
import Link from '@alltrails/denali/components/Link';
import ShowMoreText from '@alltrails/layout/components/ShowMoreText/ShowMoreText';
import { getUrlFromSlug } from '@alltrails/shared/utils/cardLinks';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import usePublicBaseUrl from '@alltrails/context/hooks/usePublicBaseUrl';
import logTrailCardClicked from '@alltrails/amplitude/events/logTrailCardClicked';
import TapFeature from '@alltrails/amplitude/enums/TapFeature';
import { COLOR_NEUTRAL_50 } from '@alltrails/denali/tokens';
import styles from './TopResults.module.scss';
import { useSelector } from '@/utils/redux';

type Props = {
  trailId: number;
  trailSlug: string;
  trailName: string;
  className: string;
  testIdPrefix: string;
  description?: string;
};

const TrailCardShowMoreText = ({ trailId, trailSlug, trailName, className, testIdPrefix, description }: Props) => {
  const languageRegionCode = useLanguageRegionCode();
  const publicBaseUrl = usePublicBaseUrl();
  const activeTrails = useSelector(state => state.map.activeTrails);
  const cardHoveredResult = activeTrails?.[0];
  const href = getUrlFromSlug(`/${trailSlug}`, publicBaseUrl, languageRegionCode);

  const handleTrailClick = useCallback(
    (tapFeature: TapFeature) => {
      logTrailCardClicked({
        trail_id: String(trailId),
        card_location: 'seo',
        detailed_card_location: 'highlights carousel',
        tap_feature: tapFeature
      });
    },
    [trailId]
  );

  return (
    <Link
      href={href}
      target="_blank"
      className={styles.resultStatsLink}
      onClick={() => handleTrailClick('more link')}
      outsideOfMugen
      title={trailName}
    >
      <ShowMoreText
        text={description}
        maxLines={3}
        className={className}
        testIdPrefix={testIdPrefix}
        preventExpansion
        useShortText
        showMoreBackgroundColor={String(cardHoveredResult?.ID) === String(trailId) ? COLOR_NEUTRAL_50 : undefined}
      />
    </Link>
  );
};

export default TrailCardShowMoreText;
